var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Chuyển nhóm",
            visible: _vm.dialogVisible,
            width: "450px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Chọn nhóm cũ" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "255px", "margin-left": "8px" },
                      attrs: { size: "small", placeholder: "Chọn nhóm cũ" },
                      model: {
                        value: _vm.selectOldGroup,
                        callback: function ($$v) {
                          _vm.selectOldGroup = $$v
                        },
                        expression: "selectOldGroup",
                      },
                    },
                    _vm._l(_vm.listOldGroup, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.nameGroup, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Chọn nhóm mới" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "255px" },
                      attrs: { size: "small", placeholder: "Chọn nhóm mới" },
                      model: {
                        value: _vm.selectNewGroup,
                        callback: function ($$v) {
                          _vm.selectNewGroup = $$v
                        },
                        expression: "selectNewGroup",
                      },
                    },
                    _vm._l(_vm.listNewGroup, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.nameGroup, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "button" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "175px" },
                  attrs: {
                    type: "success",
                    size: "medium",
                    icon: "el-icon-circle-check",
                    loading: _vm.loadingSwitchStudent,
                    disabled:
                      _vm.selectOldGroup === "" || _vm.selectNewGroup === "",
                  },
                  on: { click: _vm.handleSwitchStudentToGroup },
                },
                [_vm._v(" OK")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    size: "medium",
                    icon: "el-icon-circle-close",
                  },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v(" Đóng")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }